import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { MajorProgram } from '../builders/major_programs_builder';
import { MajorProgramsQuery } from './../queries/major_programs_query';

export class MajorSearchService {
  private _query: string;
  private _isLoading: boolean = false;
  private _page: number = 1;
  private _results: MajorProgram[];
  private _searchedPerformed: boolean = false;

  constructor(private loadSearchProgramsCommand: ICommand, private ngMajorProgramsQuery: MajorProgramsQuery) {
    this._query = '';
    this._results = [];
  }

  setSearch(): any {
    return (value: string) => {
      this.search(value);
    };
  }

  search(value: string): void {
    if (_4.isEmpty(value)) {
      this.reset();
      return;
    }

    if (value.length <= 2) {
      this._query = value;
      return;
    }

    this._isLoading = true;
    this._query = value;
    this.loadSearchProgramsCommand(value.toLowerCase()).then((result) => {
      this._isLoading = false;
      this._searchedPerformed = true;
      this._results = this.ngMajorProgramsQuery.result;
    });
  }

  reset(): void {
    this._query = '';
    this._page = 1;
    this._results = [];
    this._searchedPerformed = false;
  }

  nextPage() {
    this._page += 1;
  }

  hasMoreResults() {
    return this.ngMajorProgramsQuery.result.length > this.page * 10;
  }

  get allResults(): MajorProgram[] {
    return this._results;
  }

  getFilteredMajors(iteratee: any[], sortOrder: any) {
    return _4.orderBy(this.ngMajorProgramsQuery.result, iteratee, sortOrder).slice(0, this.page * 10);
  }

  get hasResults(): boolean {
    return this.ngMajorProgramsQuery.result.length > 0;
  }

  get hasSearchResults(): boolean {
    return this._results.length > 0;
  }

  get searchedPerformed(): boolean {
    return this._searchedPerformed;
  }

  get results(): MajorProgram[] {
    return this.ngMajorProgramsQuery.result.slice(0, this.page * 10);
  }

  get query(): any {
    return this._query;
  }

  get isLoading(): boolean {
    return this._isLoading;
  }

  get page(): number {
    return this._page;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/services/major_search_service.ts